import {Component, Inject, Input, OnInit, ViewChild} from '@angular/core';
import {LeftpanelComponent, LoaderWithProgressComponent} from '../leftpanel/leftpanel.component';
import {Location} from '@angular/common';
import {ActivatedRoute, Router} from '@angular/router';
import {ConfService} from '../conf.service';
import {ExecutorComponent} from '../executor/executor.component';
import {FormControl} from '@angular/forms';
import {TestCaseNameInputDialog} from '../testcase/testcase.component';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material';
import {ConfirmTestcaseDeletionComponent} from '../testsuite/testsuite.component';
import {WebsocketService} from '../websocket.service';
import {ListenerService} from '../listener.service';
import {Color, PluginServiceGlobalRegistrationAndOptions} from 'ng2-charts';
import {ChartOptions, ChartType} from 'chart.js';

@Component({
    selector: 'app-data-transformation',
    templateUrl: './data-transformation.component.html',
    styleUrls: ['./data-transformation.component.scss']
})
export class DataTransformationComponent implements OnInit {

    componentLoading = true;
    cloneable = false;
    editFlag: boolean;
    viewPlan = false;
    planId: any;
    fromHistory = false;
    orig_executor_name: any;
    orig_executor_version: any;
    origEntity: string;
    origVersion: string;
    @Input() partner = localStorage.getItem('partner');
    @Input() account_id = localStorage.getItem('account');
    partnerKey = localStorage.getItem('partnerKey');
    showNextPanel = false;
    @Input() showButtons = true;
    save: boolean;
    @Input() executor_name: string;
    @Input() selectedVersion: string;
    selectedExecutor: string;
    executorCategory: string;
    selectedExecutorType: string;
    executor: any;
    executor_display_name: string;
    description: string;
    queryParams = [];
    pathParams: any;
    headers = [];
    @Input() mockResponses = [];
    requestBody: any;
    executorModel: any;
    database: string;
    code = '';
    @Input() executorModelAvailable = false;
    @Input() plans = [];
    logVisible = false;
    loading = false;
    logComponentRefresh = false;
    viewResult = true;
    saveBtnLoading = false;
    @ViewChild(ExecutorComponent) executorComp: ExecutorComponent;
    showDialogOnNonWebsocketConnection: any;
    currentMessage: any;
    apiType = 'DATA TRANSFORMATION';
    action: any;
    logTimeStamp: any;
    refreshLogCount = 0;
    pubSubTopic: any;
    selectedIndex: any;
    authModel = {
        'authType': '',
        'authAttributes': {}
    };
    gatewayControl = new FormControl([]);
    prerequisites: any;
    scopeSelected = 'public';
    showResponseSection = false;
    responseText: any;
    isSidebarCollapsed: boolean = false;
    planName = '';
    currentPlanName = '';
    currentPlanIndex = 0;
    currentPlan = {};
    Index = 0;
    dbItem: any;
    dbs: any = [];
    subscribedTemp: any = [];
    apiProducers = [];
    inputformControl: FormControl = new FormControl({}, []);
    settingsData: any;
    platformServiceProviders: any;
    editablePlanIndex: number | null = null;

    constructor(public platform: LeftpanelComponent,
                private location: Location,
                private route: ActivatedRoute,
                private confPost: ConfService,
                private websocketService: WebsocketService,
                private leftPanelDataListener: ListenerService,
                private router: Router,
                public dialog: MatDialog) {
    }

    enablePlanEdit(index: number) {
        this.editablePlanIndex = index;
    }

    savePlanEdit(index: number, event: FocusEvent) {
        const element = event.target as HTMLElement;
        const newValue = (element.textContent || '').trim();

        if (newValue) {
            this.plans[index].name = newValue;
        }

        this.editablePlanIndex = null;
    }

    onPlanEnter(event: KeyboardEvent) {
        event.preventDefault(); // prevent newline
        (event.target as HTMLElement).blur(); // trigger save
    }

    async ngOnInit() {
        if (this.platform.loadingForTheFirstTime === true && this.platform.loadingForTheFirstTimeCompleted === false) {
            this.platform.initialisePlatform();
        }
        if (this.location['_platformLocation'].location.pathname === '/data-transform') {
            this.editFlag = false;
            this.route.queryParams.subscribe(async params => {
                if (params.entity != null && params.version) {
                    this.editFlag = true;
                    this.orig_executor_name = params.entity;
                    this.orig_executor_version = params.version;
                    this.origEntity = params.entity;
                    this.origVersion = params.version;
                    this.partner = params.partner;
                    this.account_id = params.account;
                    this.showNextPanel = false;
                    this.save = false;
                    this.executor_name = params.entity;
                    this.selectedVersion = params.version;
                    this.confPost.getApiExecutorByPartnerAccountByNameAndVersion(this.partner, this.account_id, this.executor_name, this.selectedVersion).subscribe(exec => {
                        const temp: any = exec;
                        if (exec) {
                            this.executor = temp;
                            this.selectedExecutor = temp['executor_method_type'];
                            this.executorCategory = temp['executor_category'];
                            this.selectedExecutorType = temp['executor_type'];
                            this.executor_display_name = temp['executor_display_name'];
                            this.description = temp['executor_description'];
                            this.queryParams = temp['queryParams'];
                            this.pathParams = temp['pathParams'];
                            this.headers = temp['headers'];
                            this.authModel = temp['authModel'];
                            this.gatewayControl = new FormControl([temp['gatewaySettings'][0]['name']]);
                            this.mockResponses = temp['mockResponses'];
                            this.requestBody = temp['requestBody'];
                            this.plans = temp['executors'];
                            this.setCurrentPlan(this.Index);
                        }
                    });
                } else if (params.viewPlan && params.plan_id) {
                    const payload = {
                        partner: this.partner,
                        pkey: this.partnerKey,
                        id: params.plan_id
                    };
                    const loaderDialog = this.dialog.open(LoaderWithProgressComponent, {
                        width: 'auto',
                        height: 'auto',
                    });
                    this.confPost.getDataTransformationPlanForPartner(payload).subscribe(res => {
                        const temp: any = res;
                        loaderDialog.close();
                        if (temp && temp.length > 0) {
                            this.plans = [];

                            for (const item of temp) {
                                const obj = {
                                    name: item.plan_name,
                                    source: item.source,
                                    target: item.target
                                };
                                this.plans.push(obj);
                            }
                            this.editFlag = false;
                            this.viewPlan = true;
                            this.planId = params.plan_id;
                            this.executor = undefined;
                            this.executor_name = undefined;
                            this.selectedVersion = undefined;
                            this.selectedExecutorType = undefined;
                            this.selectedExecutor = undefined;
                            this.executorCategory = undefined;
                            this.executor_display_name = undefined;
                            this.description = undefined;
                            this.queryParams = [];
                            this.pathParams = undefined;
                            this.headers = [];
                            this.mockResponses = [];
                            this.requestBody = {};
                            this.executorModel = undefined;
                            this.database = undefined;
                            // this.databaseSelected = this.database.db_name;
                            this.code = '';
                            this.showNextPanel = false;
                            this.save = false;
                            this.setCurrentPlan(this.Index);
                        }
                    }, err => {
                        loaderDialog.close();
                        this.platform.openSnackBar('Error while retrieving plan: ' + err.message, 'Error', {
                            duration: 15000,
                            verticalPosition: 'top',
                            horizontalPosition: 'center'
                        });
                    });

                } else {
                    this.executor = undefined;
                    this.executor_name = undefined;
                    this.selectedVersion = undefined;
                    this.selectedExecutorType = undefined;
                    this.selectedExecutor = undefined;
                    this.executorCategory = undefined;
                    this.executor_display_name = undefined;
                    this.description = undefined;
                    this.queryParams = [];
                    this.pathParams = undefined;
                    this.headers = [];
                    this.mockResponses = [];
                    this.requestBody = {};
                    this.executorModel = undefined;
                    this.database = undefined;
                    // this.databaseSelected = this.database.db_name;
                    this.code = '';
                    this.showNextPanel = false;
                    this.save = false;
                    this.plans = [];
                }
            });
            // console.log('true');
        } else {
            // console.log('false');
            this.resetAttributes();
        }
        const getAttributesForQueryBuilder = new Promise(async (resolve, reject) => {
            if (!this.cloneable) {
                if (this.platform.queryBuilderAttributes !== null && this.platform.queryBuilderAttributes !== undefined) {
                    this.dbItem = this.platform.queryBuilderAttributes;
                    this.dbs = this.dbItem.body[0];
                    resolve('success');
                } else {
                    await this.confPost.getAttributesForQueryBuilder(localStorage.getItem('partner'), localStorage.getItem('account')).subscribe(db => {
                        this.dbItem = db;
                        this.platform.queryBuilderAttributes = db;
                        this.dbs = this.dbItem.body[0]['databases'];
                        // console.log(this.dbs);
                        resolve('success');
                    }, error => {
                        resolve('failed');
                        this.platform.handleErrorGracefully(error, 'Error while retrieving attributes for data transformation. Please try again after sometime.');
                    });
                }
            } else {
                resolve('success');
            }
        });
        Promise.all([this.getPartnerServiceProviders()]).then(response => {
            this.componentLoading = false;
            // console.log(this.subscribedTemp);
        });
    }


    getPartnerServiceProviders() {
        return new Promise(async (resolve, reject) => {
            if (this.platform.settingsDataWithoutDBRef !== null && this.platform.settingsDataWithoutDBRef !== undefined) {
                this.settingsData = this.platform.settingsDataWithoutDBRef;
                if (this.partner !== 'services') {
                    if (this.settingsData['body'][0]) {
                        this.subscribedTemp = this.settingsData['body'][0]['subscriptions']['providers'];
                    }
                }
                resolve('success');
            } else {
                this.confPost.getSettingsV2CRUD(localStorage.getItem('partner'), localStorage.getItem('account'), true).subscribe(settingsData => {
                    this.settingsData = settingsData;
                    this.platform.settingsData = settingsData;
                    if (this.partner !== 'services') {
                        if (this.settingsData['body'][0]) {
                            this.subscribedTemp = this.settingsData['body'][0]['subscriptions']['providers'];
                        }
                    }
                    resolve('success');
                }, error => {
                    resolve('failed');
                    this.platform.openSnackBar('Error while getting list of settings data for partner: ' + error.error.message, 'Error', {
                        duration: 15000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                });
            }
        });
    }

    hasViewPagePermissions() {
        if (this.editFlag === true) {
            if (this.fromHistory === true) {
                return (this.platform.hasPermissions(['EDIT_HISTORY', 'EDIT_UNIFIED_QUERY_API', 'edit:' + this.partner + '=>' + this.account_id + '=>' + this.orig_executor_name + '=>' + this.orig_executor_version]));
            } else {
                return this.platform.hasPermissions(['EDIT_UNIFIED_QUERY_API', 'edit:' + this.partner + '=>' + this.account_id + '=>' + this.orig_executor_name + '=>' + this.orig_executor_version]);
            }
        } else {
            if (this.fromHistory === true) {
                return (this.platform.hasPermissions(['EDIT_HISTORY', 'CREATE_UNIFIED_QUERY_API']));
            } else {
                return this.platform.hasPlatformPermission('CREATE_UNIFIED_QUERY_API');
            }
        }
    }

    hasCopyPermissions() {
        if (this.editFlag === true) {
            return this.platform.hasPermissions(['COPY_UNIFIED_QUERY_API', 'copy:' + this.partner + '=>' + this.account_id + '=>' + this.orig_executor_name + '=>' + this.orig_executor_version]);
        } else {
            return this.platform.hasPlatformPermission('COPY_UNIFIED_QUERY_API');
        }
    }

    closeLogPanel() {
        this.logVisible = false;
        if (this.editFlag === false && this.location['_platformLocation'].location.pathname === '/data-transform') {
            this.confPost.getAPIExecutorForPartnerAccount(localStorage.getItem('partner'), localStorage.getItem('account'), this.partnerKey, this.executor_name, this.selectedVersion).subscribe(response => {
                if (response !== null && response !== undefined) {
                    this.router.navigateByUrl('/data-transform?partner=' + this.partner + '&account=' + this.account_id + '&entity=' + this.executor_name + '&version=' + this.selectedVersion);
                }
            });
        }
    }

    stringifyJson(val) {
        if (val != null) {
            return JSON.stringify(val, null, 2).trim();
        } else {
            return val;
        }
    }

    resetAttributes() {

    }


    createApi() {

    }

    createOrUpdateApi() {

    }

    istransformPlanDataValid() {
        for (const plan of this.plans) {
            if (plan.source && plan.source.sourceDatabase && plan.source.tables.length > 0 && plan.target.length > 0) {
                if (plan.source.tables.length > 1 && plan.source.query_builder.join.rules === 0) {
                    this.platform.openSnackBar('Oops! It seems youre attempting to query multiple tables. For better efficiency and accuracy, consider using a join query instead.', 'Error', {
                        duration: 3000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                    return false;
                }
                for (const target of plan.target) {
                    for (const attribute of target.attributes) {
                        if (!(attribute.attributeName && attribute.attributeValue && attribute.attributeValue.value)) {
                            return false;

                        }
                    }
                }
            } else {
                return false;
            }
        }
        return true;
    }

    listenToApiCreation(topic) {
        this.websocketService.listenToTopic(topic).subscribe(data => {
            if (data) {
                this.currentMessage = JSON.parse(data.body);
            }
        });
    }

    closeNonWSDialogBox() {
        if (this.showDialogOnNonWebsocketConnection) {
            this.showDialogOnNonWebsocketConnection.close();
        }
        if (!this.websocketService.isOpen()) {
            this.logVisible = true;
            this.refreshLogCount++;
        }
    }

    async createOrUpdateApiWithCoreApi(timeStamp, testMode = 'notests') {

        const gateways = this.executorComp.gatewayControl.value as string[];
        const gatewaySettings = [];
        if (gateways && gateways.length > 0) {
            for (const gateway of gateways) {
                gatewaySettings.push({name: gateway});
            }
        }

        // if (this.istransformPlanDataValid()) {
        if (this.plans) {

            if (gatewaySettings.length > 0) {

                const requestBodyResponse = this.executorComp.getRequestBody();
                let requestBody = {};
                if (requestBodyResponse.hasOwnProperty('__zone_symbol__value')) {
                    requestBody = requestBodyResponse['__zone_symbol__value'];
                } else {
                    requestBody = requestBodyResponse;
                }
                const executorModel = {
                    'executor_type': this.executorComp.selectedExecutorType,
                    'executor_name': this.executorComp.executor_name,
                    'executor_version': this.executorComp.selectedVersion,
                    'executor_display_name': this.executorComp.executor_display_name,
                    'executor_description': this.executorComp.description,
                    'executor_category': this.executorComp.executorCategory,
                    'executor_method_type': this.executorComp.selectedExecutor,
                    'published': true,
                    'scopeOfAccess': this.executorComp.scopeSelected,
                    'registeredAsIs': false,
                    'queryParams': this.executorComp.queryParams,
                    'headers': this.executorComp.headers,
                    'authModel': this.executorComp.authModel,
                    'requestBody': requestBody,
                    'prerequisites': this.executorComp.prerequisites,
                    'source': this.code.trim(),
                    'executors': this.plans,
                    'apiQueryModel': {},
                    'dataroot': null,
                    'attributeMappings': null,
                    'response': null,
                    'block_attributes': null,
                    'isDocumentationPublished': true,
                    'disabled': false,
                    'executionLib': null,
                    'gatewaySettings': gatewaySettings
                };


                this.logTimeStamp = timeStamp;

                const topic = this.partner + '.' + this.account_id + '.' + this.executorComp.executor_name + '.' +
                    this.executorComp.selectedVersion + '.' + timeStamp.toString() + '.' + this.action;

                const payload = {
                    'topic': topic,
                    'apiModel': executorModel
                };


                this.pubSubTopic = topic;
                this.listenToApiCreation(topic);
                this.loading = true;

                if (this.websocketService.isOpen()) {
                    this.logVisible = true;
                }

                if (!this.websocketService.isOpen()) {
                    this.showDialogOnNonWebsocketConnection = this.dialog.open(LoaderWithProgressComponent, {
                        maxWidth: '95vw',
                        maxHeight: '60vh',
                        data: {
                            message: 'API deployment is under progress. Please don\'t close the window'
                        }
                    });
                }
                // console.log(payload);
                this.loading = false;

                this.confPost.upsertAPIWithCore(localStorage.getItem('partner'), localStorage.getItem('account'), localStorage.getItem('partnerKey'), payload, false, this.editFlag, true, true).toPromise().then(response1 => {

                    this.leftPanelDataListener.changeInLeftPanelData.emit('update');
                    this.loading = false;
                    if (this.showDialogOnNonWebsocketConnection) {
                        this.showDialogOnNonWebsocketConnection.close();
                    }
                    if (!this.websocketService.isOpen()) {
                        this.logVisible = true;
                        this.refreshLogCount++;
                    }
                }, error => {

                    this.loading = false;
                    if (this.showDialogOnNonWebsocketConnection) {
                        this.showDialogOnNonWebsocketConnection.close();
                    }
                    if (!this.websocketService.isOpen()) {
                        this.logVisible = true;
                        this.refreshLogCount++;
                    }
                });

            } else {
                this.loading = false;
                this.closeNonWSDialogBox();
                this.platform.openSnackBar('Please select at least one valid API Gateway.', 'Error', {
                    duration: 7000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            }
        } else {
            this.loading = false;
            this.closeNonWSDialogBox();
            this.platform.openSnackBar('Please fill all the fields in Transformation Plan.', 'Error', {
                duration: 7000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        }
    }


    async createApiForDataTransformation(testMode = 'notests') {
        this.loading = true;
        this.logVisible = false;
        this.currentMessage = '';
        const timeStamp = Date.now();
        this.logTimeStamp = timeStamp;


        this.logComponentRefresh = true;

        if (this.editFlag === true) {
            this.action = 'redeploy';
        } else {
            this.action = 'deploy';
        }


        // this.listenAPICreation(timeStamp, this.executorComp.executor_name, this.executorComp.selectedVersion, this.action);

        if ((this.executorComp && !this.executorComp.executor_name)
            || (this.executorComp && !this.executorComp.selectedVersion)
            || (this.executorComp && !this.executorComp.selectedExecutor)
            || (this.executorComp && !this.executorComp.executorCategory)) {

            this.platform.openSnackBar('Please enter all the required fields.', 'Error', {
                duration: 5000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
            this.loading = false;
            if (this.showDialogOnNonWebsocketConnection) {
                this.showDialogOnNonWebsocketConnection.close();
            }

        } else {
            if (this.plans) {
                if (this.editFlag === true) {
                    this.createOrUpdateApiWithCoreApi(timeStamp, testMode);
                } else {
                    if (this.executorComp.isAPIAlreadyPresentCheckCompleted === false) {
                        await this.executorComp.checkForExistingEntityAndExecutor();
                        if (this.executorComp.isAPIAlreadyPresent === false) {

                            this.createOrUpdateApiWithCoreApi(timeStamp);
                        } else {
                            this.loading = false;
                            if (this.showDialogOnNonWebsocketConnection) {
                                this.showDialogOnNonWebsocketConnection.close();
                            }
                            this.platform.openSnackBar('An API with the provided name and version already exists.', 'Error', {
                                duration: 5000,
                                verticalPosition: 'top',
                                horizontalPosition: 'center'
                            });
                        }
                    }
                }
            } else {
                this.platform.openSnackBar('Select a plan.', 'Error', {
                    duration: 5000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
                this.loading = false;
                if (this.showDialogOnNonWebsocketConnection) {
                    this.showDialogOnNonWebsocketConnection.close();
                }
            }
        }
    }

    createMarginRight() {
        document.getElementById('view:unified_query_builder').style.marginRight = '400px';
    }

    removeMarginRight() {
        document.getElementById('view:unified_query_builder').style.marginRight = '0px';
    }

    savePlan() {
        if (this.plans && this.plans.length > 0) {
            const payload: any = {
                plan_name: this.plans[0].name,
                createdAt: Date.now(),
                source: this.plans[0].source,
                account: this.account_id,
                partner: this.partner,
                pkey: this.partnerKey,
                target: this.plans[0].target,
                updatedAt: Date.now()
            };
            // console.log(payload);
            this.saveBtnLoading = true;
            if (!this.viewPlan) {
                payload['action'] = 'create';
                this.confPost.postDataTransformationPlan(payload).subscribe(data => {
                    this.saveBtnLoading = false;
                    this.platform.openSnackBar('Plan saved successfully', 'Success', {
                        duration: 3000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                }, err => {
                    this.platform.handleErrorGracefully(err, 'Error while saving plan.');
                    this.saveBtnLoading = false;
                });
            } else {
                payload['action'] = 'update';
                payload['id'] = this.planId;
                this.confPost.postDataTransformationPlan(payload).subscribe(data => {
                    this.saveBtnLoading = false;
                    this.platform.openSnackBar('Plan updated successfully', 'Success', {
                        duration: 3000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                }, err => {
                    this.platform.handleErrorGracefully(err, 'Error while updating plan.');
                    this.saveBtnLoading = false;
                });
            }
        }
    }

    addNewPlan() {

        const dialogRef = this.dialog.open(TestCaseNameInputDialog, {
            width: '400px',
            data: {name: '', type: 'plan'}
        });
        dialogRef.afterClosed().subscribe(name => {
            if (name && name !== '' && name !== ' ') {
                const duplicatePlans = this.plans.filter((v, i) => v.name === name);
                if (!duplicatePlans.length) {
                    const obj = {
                        name: name,
                        source: [{
                            name: 'test',
                            source_type: 'API',
                            sourceProvider: {},
                            sourceExecutor: {method: '', apiUrl: '', params: {}, responseAttributes: []},
                            sourceConnector: {},
                            source_response_type: 'array<json>',
                            rootMapping: '',
                            sourceDatabase: '',
                            sourceDatabaseType: '',
                            sourceMethod: '',
                            sourceDatabaseObject: '',
                            tables: [],
                            code: '',
                            query_builder: {
                                fields: []
                            },
                            chunkStrategy: {
                                limit: 3,
                                totalRecords: 3,
                                paginationMethod: 'pagelimit',
                                paginationFields: {
                                    offsetField: 'page',
                                    limitField: 'row_count'
                                }
                            }

                        }],
                        target: [{
                            name: 'test',
                            target_type: 'API',
                            targetProvider: {},
                            targetExecutor: {method: '', apiUrl: '', params: {}},
                            targetConnector: {},
                            process_type_into_target: 'json',
                            fieldMappings: [
                                {
                                    targetfield: '',
                                    mappingType: 'sourceAttribute',
                                    attributeType: 'text',
                                    policyEnabled: false,
                                    policy: '',
                                    sourcefield: '',
                                    value: '',
                                    query: '',
                                    attributeValue: {
                                        sourcefield: '',
                                        value: ''
                                    }
                                }
                            ],
                            sourceUniqueIdentifier: 'id',
                            targetDatabase: '',
                            targetDatabaseType: '',
                            targetTable: '',
                            operation: 'INSERT',
                            condition: '',
                            code: '',
                            attributes: [
                                {
                                    attributeName: '',
                                    isCalculatedField: false,
                                    claculatedField: {
                                        fields: [],
                                        formula: ''
                                    },
                                    attributeValue: {
                                        type: '',
                                        method: '',
                                        value: ''
                                    }
                                }
                            ],
                            batchStrategy: {
                                limit: 100,
                                limitBy: 'minute',
                                interval: 30,
                                migrateSample: false,
                                sampleSize: 5,
                                immediateFirstBatch: false,
                                retry: false,
                                createErrorBatchOnEmptyRecords: true,
                                createErrorBatchOnApiError: true
                            },
                            dependentTargets: [],
                        }],
                        sourceDataExtender: [
                            {
                                name: 'test',
                                source_type: 'API',
                                sourceProvider: {},
                                sourceExecutor: {method: '', apiUrl: '', params: {}, responseAttributes: []},
                                sourceConnector: {},
                                source_response_type: 'array<json>',
                                rootMapping: '',
                                sourceDatabase: '',
                                sourceDatabaseType: '',
                                sourceMethod: '',
                                sourceDatabaseObject: '',
                                tables: [],
                                code: '',
                                query_builder: {
                                    fields: []
                                },
                            }
                        ],
                    };
                    this.plans.push(obj);
                    this.planName = name;
                    this.currentPlanName = name;
                    this.currentPlanIndex = this.Index;
                    this.currentPlan = obj;
                    this.Index = this.Index + 1;
                } else {
                    const msgText = 'Plan';
                    this.platform.openSnackBar(msgText + ' named ' + name + ' already exists', 'Error', {
                        duration: 3000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                    this.addNewPlan();
                }

            }
        });
    }

    deletePlan(i) {
        const dialogRef = this.dialog.open(ConfirmTestcaseDeletionComponent, {
            width: '400px',
            data: {name: this.plans[i].name}
        });
        dialogRef.afterClosed().subscribe(response => {
            if (response && response === 'yes') {
                this.plans.splice(i, 1);
                this.currentPlanIndex = this.currentPlanIndex !== 0 ? this.currentPlanIndex - 1 : this.currentPlanIndex;
                this.currentPlanName = this.plans.length ? this.plans[this.currentPlanIndex].name : '';
                this.Index = this.Index !== 0 ? this.Index - 1 : this.Index;
            }
        });

    }

    setCurrentPlan(index) {
        this.currentPlanIndex = index;
        this.currentPlanName = this.plans[index].name;
        this.currentPlan = this.plans[index];
    }

    display(newItem: any) {
        this.currentPlan = newItem;
        // console.log(this.currentPlan);
    }

    isValidPlan() {
        return true;
    }

    executeAPI() {
        if (this.isValidPlan) {
            const loaderDialog: any = this.dialog.open(LoaderWithProgressComponent, {
                width: '30vw',
                maxWidth: '95vw',
                height: 'auto',
                data: {
                    message: 'Processing Data Transformation...'
                }
            });

            this.plans = this.plans.map(user => ({
                ...user,
                executedBy: localStorage.getItem('signInEmail'),
            }));
            const payload = {
                name: this.plans[0].name,
                executedBy: localStorage.getItem('signInEmail'),
                partnerKey: localStorage.getItem('partnerKey'),
                partner: localStorage.getItem('partner'),
                scheduledTime: Date.now(),
                transformationChunkMethod: 'default',
                transformationModels: this.plans
            };
            this.confPost.transformData(payload).subscribe(res => {
                const temp: any = res;
                loaderDialog.close();
                if (temp && temp['transformationPlanId']) {
                    this.router.navigate(['/data-transform/result', res['transformationPlanId']]);
                }
            }, error => {
                loaderDialog.close();
            });


        }

    }
}


@Component({
    selector: 'data-transformation-test-result',
    templateUrl: 'data-tranformation-test-result.html',
    styleUrls: ['data-transformation-test-result.css']
})
export class DataTransformationTestResultDialog {

    selectedTab = 0;

    constructor(@Inject(MAT_DIALOG_DATA) public data: any, public dialogRef: MatDialogRef<DataTransformationTestResultDialog>) {
        console.log(data);
    }

    close() {
        this.dialogRef.close();
    }

    getMigrationId(): string | null {
        if (
            this.data &&
            this.data.transformationPlanResults &&
            this.data.transformationPlanResults.transformationPlanResults &&
            this.data.transformationPlanResults.transformationPlanResults.transformationResults &&
            this.data.transformationPlanResults.transformationPlanResults.transformationResults.length > 0
        ) {
            const firstTransformationResult = this.data.transformationPlanResults.transformationPlanResults.transformationResults[0];

            if (
                firstTransformationResult.transformationResult &&
                firstTransformationResult.transformationResult.migrationResults &&
                firstTransformationResult.transformationResult.migrationResults.length > 0
            ) {
                const firstMigrationResult = firstTransformationResult.transformationResult.migrationResults[0];

                if (firstMigrationResult.migrationId) {
                    return firstMigrationResult.migrationId;
                }
            }
        }

        console.warn('Migration ID not found.');
        return null;
    }


    getPlanName() {
        if (this.data && this.data.plans && this.data.plans.length > 0) {
            return this.data.plans[0].name;
        }
    }


}


